import { css } from '@emotion/react';

export const SubLabel = css`
  & > label {
    font-family: Noto Sans KR;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 23px;
  }
`;
